var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_10_2",
    "data-name": "Component 10 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 20,
    height: 14,
    fill: "#600097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M0,1.517A1.975,1.975,0,0,1,.619.425,1.835,1.835,0,0,1,1.84,0H14.221c1.328,0,2.656,0,3.984,0A1.75,1.75,0,0,1,19.94,1.32a1.851,1.851,0,0,1,.06.5Q20,7,20,12.181A1.759,1.759,0,0,1,18.182,14Q10,14,1.817,14A1.75,1.75,0,0,1,.036,12.568c-.007-.031,0-.066-.036-.085Zm2.092-.339a.51.51,0,0,0,.164.235L8.7,7.8a1.812,1.812,0,0,0,.692.455,1.783,1.783,0,0,0,1.951-.5q3.186-3.16,6.378-6.315c.076-.075.147-.155.242-.256ZM2,12.814H17.85c-1.578-1.6-3.2-3.242-4.811-4.885-.089-.091-.14-.076-.219.005-.244.251-.494.5-.745.742a2.924,2.924,0,0,1-3.81.285,8.808,8.808,0,0,1-1.046-.989c-.123-.123-.184-.118-.3,0Q4.635,10.24,2.347,12.5c-.1.1-.206.189-.347.317M18.821,2.005c-.045.037-.061.049-.074.062Q16.325,4.465,13.9,6.86c-.123.121-.1.18.008.287q2.412,2.381,4.818,4.767c.025.024.042.072.094.042ZM1.262,1.983l-.071.066V11.97a.34.34,0,0,0,.051-.031Q3.686,9.523,6.131,7.107c.11-.108.053-.154-.02-.227C5.46,6.236,4.8,5.6,4.162,4.944c-.971-.983-1.934-1.973-2.9-2.961",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.a913f9e7df4f8333e1dcac8d61154254.svg";
export { ForwardRef as ReactComponent };